import { render, staticRenderFns } from "./ListSales.vue?vue&type=template&id=6308343f&"
import script from "./ListSales.vue?vue&type=script&lang=js&"
export * from "./ListSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports